import { Stack } from '@mui/material';
import { CasColorSwatch, CasCRUDTable } from 'src/compass/shared/components';
import { CasRenderBoolTrueFalse } from 'src/compass/shared/components/CasTable/CellRender/CasRenderBool';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import { CasTagChip, CasYesNoSelect } from 'src/compass/application';

import TagForm from './TagForm';

// Blank for a tag that uses the default color.
const renderColor = ({ row }: ICasRenderCellProps) =>
  row.color && (
    <Stack direction="row" spacing={1} alignItems="center">
      <CasColorSwatch value={row.color} />
      <span>{row.color}</span>
    </Stack>
  );

export default function TagsTab() {
  return (
    <CasCRUDTable
      entityTitle="Tag"
      entity="Tag"
      columns={[
        {
          field: 'name',
          showEditOnclick: true,
          render: ({ row }: ICasRenderCellProps) => <CasTagChip tag={row} />,
        },
        {
          field: 'color',
          render: renderColor,
        },
        {
          field: 'isActive',
          label: 'Active',
          render: CasRenderBoolTrueFalse,
        },
      ]}
      filters={[
        {
          name: 'searchName',
          label: 'Name',
        },
        {
          type: 'component',
          name: 'isActive',
          label: 'Active',
          initialValue: true,
          includeAllOption: true,
          component: CasYesNoSelect,
        },
      ]}
      editForm={TagForm}
      defaultRowsPerPage={20}
    />
  );
}
